export interface DashboardError {
  status: string;
  code: string | null;
  description: string;
  errorKey: string;
  count: number;
}

// Paraguay is permanently UTC-03 (IANA 2025a). This fixed display zone also
// works on browsers whose timezone data still applies the old winter offset.
export const DASHBOARD_TIME_ZONE = "Etc/GMT+3";

export interface DashboardCounts {
  pendingMonth: number;
  errorsMonth: number;
}

export interface DocumentDashboard {
  generatedAt: string;
  monthStart: string;
  timezone: string;
  totals: DashboardCounts;
  byType: (DashboardCounts & {
    type: string;
    label: string;
    topErrors: DashboardError[];
  })[];
  topErrors: DashboardError[];
}

export const documentLabels: Record<string, string> = {
  invoices: "Facturas",
  credit_notes: "Notas de crédito",
  debit_notes: "Notas de débito",
  remission_notes: "Notas de remisión",
  auto_invoices: "Autofacturas",
  receipts: "Recibos",
};

export const statusLabels: Record<string, string> = {
  error: "Error",
  recoverable_error: "Error recuperable",
  set_unknown_error: "Error desconocido",
  cancellation_failed: "Anulación fallida",
  disagreement_failed: "Disconformidad fallida",
  nomination_failed: "Nominación fallida",
  pending: "Pendiente",
  generated: "Generado",
  uploaded_to_set: "Subido a SIFEN",
  approved_by_set: "Aprobado",
  cancelled: "Anulado",
  cancellation_requested: "Anulación solicitada",
  disagreement_requested: "Disconformidad solicitada",
  disagreement_accepted: "Disconformidad aceptada",
  resend_requested: "Reenvío solicitado",
  nomination_requested: "Nominación solicitada",
  nominated: "Nominado",
};

export const dashboardMetrics = [
  {
    key: "pendingMonth",
    metric: "pending",
    label: "Pendientes de procesamiento",
    color: "#2877b5",
  },
  {
    key: "errorsMonth",
    metric: "errors",
    label: "Con errores",
    color: "#c74444",
  },
] as const;

export const documentListPaths: Record<string, string> = {
  invoices: "/invoices/",
  credit_notes: "/credit_notes/",
  debit_notes: "/debit_notes/",
  remission_notes: "/remission_notes/",
  auto_invoices: "/auto_invoices/",
  receipts: "/receipts/",
};

export const documentsPath = (
  type: string,
  metric: string,
  error?: DashboardError,
) => {
  if (type && !error && documentListPaths[type]) {
    return `${documentListPaths[type]}?dashboard_metric=${metric}`;
  }
  const params = new URLSearchParams({ metric });
  if (error) {
    params.set("error_key", error.errorKey);
    params.set("error_status", error.status);
  }
  return `/dashboard/documents/${type || "all"}/?${params}`;
};
